export default __webpack_public_path__ + "static/media/generic_menu_music.85fe01f7.mp3";